import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// react-router's history.push (used both by plain <Link to="...#anchor">
// clicks and by the DQ Agent's auto-navigation in PbdqAgentChatFlow's
// PageLink) never triggers the browser's native scroll-to-anchor behavior —
// that only happens on a real full-page load. Left alone, navigating to a
// route + #hash across a route change lands at the top of the new page
// instead of at the anchored section (e.g. Pricing's #calculator,
// #workspace, #apply). This restores that behavior for every page inside
// PbdqAppShell. Rendered as a sibling of the routed Switch so its effect
// runs in the same commit as the newly matched page, after its DOM (incl.
// the target section) has already committed.
const PbdqScrollToHash = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) return undefined;
        const id = hash.slice(1);
        let attempts = 0;
        let raf;
        const tryScroll = () => {
            const el = document.getElementById(id);
            if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
            if (attempts++ < 20) raf = requestAnimationFrame(tryScroll);
        };
        tryScroll();
        return () => cancelAnimationFrame(raf);
    }, [pathname, hash]);

    return null;
};

export default PbdqScrollToHash;
